import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const KEY = 'rbf_privacy_notice_ack_v1';

// Lightweight one-time data/cookie notice. The site uses only essential/functional storage
// (auth token, this acknowledgement) — no tracking cookies — so this is an informational notice.
export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch (e) { /* storage unavailable */ }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(KEY, new Date().toISOString()); } catch (e) { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[90] p-4" data-testid="cookie-notice">
      <div className="max-w-4xl mx-auto bg-slate-900 text-white rounded-2xl shadow-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="text-amber-400 flex-shrink-0" size={24} />
        <p className="text-sm text-slate-200 flex-1">
          We use only essential storage needed to run this website (such as keeping you signed in). We do not use
          third-party tracking or advertising cookies. Personal data you submit is processed as described in our{' '}
          <Link to="/privacy" className="text-amber-300 underline">Privacy Policy</Link>.
        </p>
        <button
          onClick={dismiss}
          className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-5 py-2 rounded-lg text-sm whitespace-nowrap transition-colors"
          data-testid="cookie-notice-accept"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
